<div class="row mt-3">
  <div class="col-12">
    <h3 class="alert alert-danger">{{text}}</h3>
  </div>
</div>
